var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowFaceEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_328_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2867 36.3652C33.1534 33.7214 39.0087 23.5797 36.3649 13.7131C33.7212 3.84643 23.5795 -2.0089 13.7128 0.634852C3.84616 3.2786 -2.00915 13.4203 0.634606 23.2869C3.27837 33.1536 13.4201 39.0089 23.2867 36.3652Z",
    fill: "#FBD433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2071 26.4701C9.40669 26.4701 8.75781 25.8212 8.75781 25.0209C8.75781 24.2205 9.40669 23.5716 10.2071 23.5716H26.7935C27.5939 23.5716 28.2428 24.2205 28.2428 25.0209C28.2428 25.8212 27.5939 26.4701 26.7935 26.4701H10.2071ZM12.1372 12.8275C13.4984 12.8275 14.6018 14.2245 14.6018 15.9477C14.6018 17.6711 13.4984 19.0679 12.1372 19.0679C10.7761 19.0679 9.67269 17.6711 9.67269 15.9477C9.67269 14.2245 10.7761 12.8275 12.1372 12.8275ZM24.8632 12.8275C26.2244 12.8275 27.3278 14.2245 27.3278 15.9477C27.3278 17.6711 26.2244 19.0679 24.8632 19.0679C23.502 19.0679 22.3986 17.6711 22.3986 15.9477C22.3986 14.2245 23.502 12.8275 24.8632 12.8275Z",
    fill: "#40270E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.556 14.0187C12.0318 14.0187 12.4176 14.426 12.4176 14.9285C12.4176 15.4309 12.0318 15.8382 11.556 15.8382C11.08 15.8382 10.6943 15.4309 10.6943 14.9285C10.6943 14.426 11.08 14.0187 11.556 14.0187ZM24.2819 14.0187C24.7577 14.0187 25.1436 14.426 25.1436 14.9285C25.1436 15.4309 24.7577 15.8382 24.2819 15.8382C23.8061 15.8382 23.4203 15.4309 23.4203 14.9285C23.4203 14.426 23.8061 14.0187 24.2819 14.0187Z",
    fill: "#89611B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_328_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFaceEmoji);
export default __webpack_public_path__ + "static/media/yellow-face-emoji.e8d90346d01db293f74afb99ee5620a3.svg";
export { ForwardRef as ReactComponent };